module.exports = __webpack_public_path__ + "media/src/img/slider_title_1-ca8d2a9950b47750a9e2bf7e51b7cca7.png";